
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destination/[continent]/[country]/travel-guides/[travelGuide]",
      function () {
        return require("private-next-pages/destination/[continent]/[country]/travel-guides/[travelGuide].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destination/[continent]/[country]/travel-guides/[travelGuide]"])
      });
    }
  